export default __webpack_public_path__ + "static/media/YAS0660.34I-31178_-17722_0.3011418f.jpg";